import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, MessageCircle, FileText, Plus, X } from "lucide-react";
import { CONTACT, whatsappLink } from "@/lib/api";
import { useQuote } from "@/context/QuoteContext";

export default function FloatingButtons() {
  const [open, setOpen] = useState(false);
  const { openQuote } = useQuote();

  const actions = [
    {
      key: "whatsapp", label: "WhatsApp", icon: MessageCircle, color: "bg-[#25D366] text-white",
      onClick: () => window.open(whatsappLink(), "_blank"),
    },
    {
      key: "call", label: "Call Now", icon: Phone, color: "bg-forest text-cream",
      onClick: () => (window.location.href = `tel:${CONTACT.phoneRaw}`),
    },
    {
      key: "quote", label: "Request Quote", icon: FileText, color: "bg-gold text-ink",
      onClick: () => openQuote(),
    },
  ];

  return (
    <div className="fixed bottom-6 right-5 z-40 flex flex-col items-end gap-3" data-testid="floating-buttons">
      <AnimatePresence>
        {open &&
          actions.map((a, i) => (
            <motion.button
              key={a.key}
              initial={{ opacity: 0, scale: 0.5, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0, transition: { delay: i * 0.05 } }}
              exit={{ opacity: 0, scale: 0.5, y: 10 }}
              onClick={a.onClick}
              data-testid={`float-${a.key}`}
              className={`flex items-center gap-2 pl-4 pr-5 py-3 rounded-full shadow-lg ${a.color} font-medium text-sm`}
            >
              <a.icon size={18} />
              {a.label}
            </motion.button>
          ))}
      </AnimatePresence>
      <button
        onClick={() => setOpen(!open)}
        data-testid="float-toggle"
        aria-label="Quick actions"
        className="w-14 h-14 rounded-full bg-forest text-cream grid place-items-center shadow-xl hover:bg-olive transition-colors"
      >
        <motion.span animate={{ rotate: open ? 135 : 0 }} transition={{ duration: 0.3 }}>
          {open ? <X size={24} /> : <Plus size={24} />}
        </motion.span>
      </button>
    </div>
  );
}
